export class MovimientoInventarioRegistrado {
  constructor(movimiento) {
    this.eventName = "MovimientoInventarioRegistrado";
    this.aggregateType = "MovimientoInventario";
    this.aggregateId = movimiento.id_movimiento;

    this.ocurrio = new Date();

    this.data = {
      producto_id: movimiento.id_producto,
      cantidad: movimiento.cantidad,
      origen: movimiento.origen
    };
  }
}